var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getMixPanelEvents } from '@/clients/admin';
import { Component, Vue } from 'vue-property-decorator';
let EventHistoryTableTab = class EventHistoryTableTab extends Vue {
    constructor() {
        super(...arguments);
        this.metrics = [];
    }
    async mounted() {
        const userId = this.$store.getters['admin/get_selected_user'];
        const response = await getMixPanelEvents(userId);
        if (response && response.status == 200 && response.data) {
            this.metrics = response.data.metrics;
        }
    }
};
EventHistoryTableTab = __decorate([
    Component({})
], EventHistoryTableTab);
export default EventHistoryTableTab;
